import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createProductsAndExchangeToProductsFn, createReturnReasonConfigBottom, createReturnReasonConfigTop } from "../mockCore";

const productsAndExchangeToProductsFn = createProductsAndExchangeToProductsFn([
    {
        product: {
            productVariantId: 10,
            sessionItemId: 1,
            productName: "Breezy Shirt",
            imageSrc: "/mocks/Breezy Shirt Blue Stripe.png",
            imageAlt: "/mocks/Breezy Shirt Blue Stripe.png",
            quantity: 1,
            purchasePrice: 1099,
            properties: [
                {
                    type: "Size",
                    value: "S",
                },
                {
                    type: "Color",
                    value: "Blue Stripe",
                },
            ],
            returnReasonConfig: createReturnReasonConfigTop(),
        },
        exchangeToProductsData: {
            originalProductVariants: [
                {
                    id: "1",
                    imageUrl: "/mocks/Breezy Shirt Blue Stripe.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Blue Stripe",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Breezy Shirt Blue Stripe.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Blue Stripe",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Breezy Shirt White.png",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 3,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Breezy Shirt White.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Breezy Shirt White.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Breezy Shirt Apricot.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Apricot",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "8",
                    imageUrl: "/mocks/Breezy Shirt Apricot.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Apricot",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "9",
                    imageUrl: "/mocks/Breezy Shirt Apricot.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Apricot",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        },
    },
    {
        product: {
            productVariantId: 20,
            sessionItemId: 2,
            productName: "First Choice Pants",
            imageSrc: "/mocks/First Choice Pants Greige.png",
            imageAlt: "/mocks/First Choice Pants Greige.png",
            quantity: 1,
            purchasePrice: 1499,
            properties: [
                {
                    type: "Size",
                    value: "S",
                },
                {
                    type: "Color",
                    value: "Greige",
                },
            ],
            returnReasonConfig: createReturnReasonConfigBottom(),
        },
        exchangeToProductsData: {
            originalProductVariants: [
                {
                    id: "1",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
            ],
        },
    },
    {
        product: {
            productVariantId: 30,
            sessionItemId: 3,
            productName: "Rufus T-shirt",
            imageSrc: "/mocks/Rufus-tee.png",
            imageAlt: "/mocks/Rufus-tee.png",
            quantity: 1,
            purchasePrice: 799,
            properties: [
                {
                    type: "Size",
                    value: "S",
                },
                {
                    type: "Color",
                    value: "White",
                },
            ],
            returnReasonConfig: createReturnReasonConfigTop(),
        },
        exchangeToProductsData: {
            originalProductVariants: [
                {
                    id: "1",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Size",
                            value: "XL",
                        },
                    ],
                },
            ],
        },
    },
]);

export function getExchangeToProducts({ productId }) {
    return productsAndExchangeToProductsFn.exchangeToProductsFn({ productId });
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        pickupDateSelectionAllowed: true,
        paidShipping: 40,
        turnrShippingCost: 39,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: productsAndExchangeToProductsFn?.products,
    };
}
